import React from 'react'


const PrintStatusPedPDV = props => {
    
    const {status} = props
    
    let tColor = 'red'
    let text = 'Desconhecido'

    switch (status) {
        case 'P':
            tColor = '#eba817'
            text = 'Pendente'
            break;
        case 'G':
            tColor = '#8af046'
            text = 'Pago'
            break;
        case 'F':
            tColor = '#46f0ea'
            text = 'Finalizado'
            break;
    
        default:
            break;
    }

    return (
        <div style={{color: tColor}}>
            {text}
        </div>
        )
}

export default PrintStatusPedPDV